import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import LeaderboardOutlinedIcon from "@mui/icons-material/LeaderboardOutlined";
import {
  Avatar,
  Box,
  Button,
  Chip,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import TableMenu from "../components/TableMenu/TableMenu";
import SwapVertOutlinedIcon from "@mui/icons-material/SwapVertOutlined";

export const superAdmin_Data = [
  {
    id: 1,
    label: "Manage Users",
    field: "manage_users",
    icon: <PeopleOutlineIcon sx={{ width: "40px", height: "40px" }} />,
    route: "/cms/users-list",
  },
  {
    id: 2,
    label: "Reports",
    field: "reports",
    icon: <LeaderboardOutlinedIcon sx={{ width: "40px", height: "40px" }} />,
    route: "/cms/reports",
  },
];

export const employeeTableHeader = [
  { label: "UserName", field: "name", sort: <SwapVertOutlinedIcon /> },
  { label: "Email", field: "email", sort: <SwapVertOutlinedIcon /> },
  // { label: "Role", field: "role" },
  { label: "Location", field: "locationName", sort: <SwapVertOutlinedIcon /> },
  { label: "Status", field: "status", sort: <SwapVertOutlinedIcon /> },
  { label: "", field: "action", sort: "" },
];

export const EmployeeTableColumns = [
  {
    name: "name",
    label: "User Name",

    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Avatar>
              {value
                .split(" ")
                .map((word) => word[0])
                .join("")}
            </Avatar>
            {value}
          </div>
        );
      },
    },
  },
  {
    name: "email",
    label: "Email",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "role",
    label: "Role",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "location",
    label: "Location",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "status",
    label: "Status",
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <Chip
            label={value}
            sx={{
              color: "#FFFFFF",
              backgroundColor: value === "Active" ? "green" : "red",
              fontWeight: "bold",
            }}
          />
        );
      },
    },
  },
  {
    // name: "action",
    // label: "action",
    options: {
      customBodyRender: (value, tableMeta) => {
        return (
          <IconButton onClick={() => console.log(tableMeta)}>
            <Box>
              <MoreVertIcon />
              <TableMenu />
            </Box>
          </IconButton>
        );
      },
    },
  },
];

export const EmployeesDataTable = (data) => {
  // let employeesData = [];
  let employeeData = data?.data?.map((item, i) => {
    let userName = `${item.firstName} ${item.lastName}`;
    let details = {
      userName: userName,
      email: item.email,
      role: item.designation,
      // location: item.location ? item.location[0].District : "",
      status: item.isActive ? "Active" : "inActive",
    };
    return Object.values(details).map((item) => item);
  });
  return employeeData;
};

export const EmployeesData = [
  [
    "Dilip Nilakhe",
    "dilip.nilakhe@infojiniconsulting.com",
    "Employee",
    "Mumbai",
    "Active",
  ],
  [
    "Abhijeet Pawar",
    "abhijeet.pawar@infojiniconsulting.com",
    "Employee",
    "Mumbai",
    "Active",
  ],
  [
    "Joginder Sharma",
    "joginder.s@infojiniconsulting.com",
    "Employee",
    "Noida",
    "Inactive",
  ],
  [
    "Sivaram Krishna Javaji",
    "sivaram.krishna@infojiniconsulting.com",
    "Employee",
    "Hyderabad",
    "Active",
  ],
  [
    "Yasar Shaikh",
    "yasar.s@infojiniconsulting.com",
    "Employee",
    "Mumbai",
    "Active",
  ],
  [
    "Bharath",
    "dilip.nilakhe@infojiniconsulting.com",
    "Employee",
    "Mumbai",
    "Active",
  ],
  [
    "Guru",
    "abhijeet.pawar@infojiniconsulting.com",
    "Employee",
    "Mumbai",
    "Active",
  ],
  [
    "Gopi",
    "joginder.s@infojiniconsulting.com",
    "Employee",
    "Noida",
    "Inactive",
  ],
  [
    "Sivaram Krishna",
    "sivaram.krishna@infojiniconsulting.com",
    "Employee",
    "Hyderabad",
    "Active",
  ],
  ["Yasar", "yasar.s@infojiniconsulting.com", "Employee", "Mumbai", "Active"],
  [
    "Dilip Nilakhe",
    "dilip.nilakhe@infojiniconsulting.com",
    "Employee",
    "Mumbai",
    "Active",
  ],
  [
    "Abhijeet Pawar",
    "abhijeet.pawar@infojiniconsulting.com",
    "Employee",
    "Mumbai",
    "Active",
  ],
  [
    "Joginder Sharma",
    "joginder.s@infojiniconsulting.com",
    "Employee",
    "Noida",
    "Inactive",
  ],
  [
    "Sivaram Krishna Javaji",
    "sivaram.krishna@infojiniconsulting.com",
    "Employee",
    "Hyderabad",
    "Active",
  ],
  [
    "Yasar Shaikh",
    "yasar.s@infojiniconsulting.com",
    "Employee",
    "Mumbai",
    "Active",
  ],
  [
    "Dilip Nilakhe",
    "dilip.nilakhe@infojiniconsulting.com",
    "Employee",
    "Mumbai",
    "Active",
  ],
  [
    "Abhijeet Pawar",
    "abhijeet.pawar@infojiniconsulting.com",
    "Employee",
    "Mumbai",
    "Active",
  ],
  [
    "Joginder Sharma",
    "joginder.s@infojiniconsulting.com",
    "Employee",
    "Noida",
    "Inactive",
  ],
  [
    "Sivaram Krishna Javaji",
    "sivaram.krishna@infojiniconsulting.com",
    "Employee",
    "Hyderabad",
    "Active",
  ],
  [
    "Yasar Shaikh",
    "yasar.s@infojiniconsulting.com",
    "Employee",
    "Mumbai",
    "Active",
  ],
];

export const userTypeData = [
  { id: 1, label: "Employee" },
  { id: 2, label: "Vendor" },
];

export const userlocationData = [
  { id: 1, label: "mumbai" },
  { id: 2, label: "hyderabad" },
  { id: 3, label: "noida" },
  { id: 4, label: "mohali" },
];

export const userPermissions = [
  { id: 1, label: "Select All" },
  { id: 2, label: "Manage Guests" },
  { id: 1, label: "Access To Reports" },
];

export const mealDataByLocation = [
  {
    diet_name: "chicken",
    vendorId: 3,
    vendor_minimum_guarantee: 20,
    vendor_per_plate_price: 140,
  },
  {
    diet_name: "chineese",
    vendorId: 3,
    vendor_minimum_guarantee: 30,
    vendor_per_plate_price: 120,
  },
  {
    diet_name: "egg",
    vendorId: 3,
    vendor_minimum_guarantee: 20,
    vendor_per_plate_price: 120,
  },
  {
    diet_name: "veg",
    vendorId: 3,
    vendor_minimum_guarantee: 10,
    vendor_per_plate_price: 85,
  },
  {
    diet_name: "veg",
    vendorId: 3,
    vendor_minimum_guarantee: 30,
    vendor_per_plate_price: 85,
  },
];

// export const invoiceDescriptionByLocation = [
//   {
//     mealDate: "2025-02-07",
//     dayOfWeek: "Friday   ",
//     dayId: 5,
//     details: [
//       {
//         mealType: "self",
//         mealCount: 2,
//       },
//     ],
//     vendorId: 2,
//     days_name: "Friday",
//     diet_name: "chicken",
//     vendor_per_plate_price: 110,
//     vendor_minimum_guarantee: 90,
//     meal_type_id: 2,
//     diet_type_id: 2,
//     meal_display_name: "Dinner",
//   },
//   {
//     mealDate: "2025-02-10",
//     dayOfWeek: "Monday   ",
//     dayId: 1,
//     details: [
//       {
//         mealType: "self",
//         mealCount: 36,
//       },
//     ],
//     vendorId: 2,
//     days_name: "Monday",
//     diet_name: "veg",
//     vendor_per_plate_price: 85,
//     vendor_minimum_guarantee: 90,
//     meal_type_id: 2,
//     diet_type_id: 1,
//     meal_display_name: "Dinner",
//   },
//   {
//     mealDate: "2025-02-11",
//     dayOfWeek: "Tuesday  ",
//     dayId: 2,
//     details: [
//       {
//         mealType: "self",
//         mealCount: 53,
//       },
//     ],
//     vendorId: 2,
//     days_name: "Tuesday",
//     diet_name: "veg",
//     vendor_per_plate_price: 85,
//     vendor_minimum_guarantee: 90,
//     meal_type_id: 2,
//     diet_type_id: 1,
//     meal_display_name: "Dinner",
//   },
//   {
//     mealDate: "2025-02-12",
//     dayOfWeek: "Wednesday",
//     dayId: 3,
//     details: [
//       {
//         mealType: "self",
//         mealCount: 50,
//       },
//       {
//         mealType: "guest",
//         mealCount: 1,
//       },
//     ],
//     vendorId: 2,
//     days_name: "Wednesday",
//     diet_name: "egg",
//     vendor_per_plate_price: 90,
//     vendor_minimum_guarantee: 90,
//     meal_type_id: 2,
//     diet_type_id: 3,
//     meal_display_name: "Dinner",
//   },
//   {
//     mealDate: "2025-02-13",
//     dayOfWeek: "Thursday ",
//     dayId: 4,
//     details: [
//       {
//         mealType: "self",
//         mealCount: 47,
//       },
//     ],
//     vendorId: 2,
//     days_name: "Thursday",
//     diet_name: "veg",
//     vendor_per_plate_price: 85,
//     vendor_minimum_guarantee: 90,
//     meal_type_id: 2,
//     diet_type_id: 1,
//     meal_display_name: "Dinner",
//   },
// ];
